<template>
  <div>
    <div class="d-flex justify-content-between">
      <b-button
        v-b-modal.section-modal
        variant="primary"
        @click="section_edit = false"
      >
        <feather-icon icon="PlusIcon" />
        {{ $t("objects.add_entryway") }}
      </b-button>
      <div class="d-flex align-items-center">
        <b-button
          variant="info"
          class="mr-1"
          v-b-modal.entrance-dublicate-modal
        >
          Дублирование подъездов
        </b-button>
        <b-button
          variant="warning"
          @click="
            $router.push({
              name: 'object-price-history',
              params: {
                id: GET_ONE_APARTMENT.rc_object,
                apartment: Number($route.params.id),
                section: active_tab_id,
              },
            })
          "
        >
          {{ $t("objects.view_price_history") }}
        </b-button>
      </div>
    </div>
    <div class="mt-1">
      <b-tabs>
        <b-tab
          v-for="(tab, index) in GET_SECTIONS"
          :key="index"
          lazy
          @click="showSection(tab.id)"
        >
          <template #title>
            <span class="mr-1">{{ tab.title }}</span>
            <b-button
              v-b-modal.section-modal
              variant="link"
              class="p-25"
              @click="editSection(tab)"
            >
              <feather-icon class="mr-0 text-warning" icon="EditIcon" />
            </b-button>
            <b-button
              variant="link"
              class="p-25"
              @click="deactivateSection(tab.id)"
            >
              <feather-icon class="mr-0 text-danger" icon="XIcon" />
            </b-button>
          </template>
          <div>
            <b-button
              v-b-modal.stage-modal
              class="w-100"
              variant="outline-primary"
              @click="openNewStageModal(tab.id)"
            >
              <feather-icon icon="PlusIcon" />
              {{ $t("objects.add_floor") }}
            </b-button>
            <b-row class="mt-1">
              <b-col v-for="stage in GET_STAGES" :key="stage.id" cols="12">
                <collapsible-stage-card
                  :stage-title="
                    `${stage.title} {${$_moneyFormatter(stage.price_per_kv)}}`
                  "
                  :items="stage.flats"
                  @deactivateStage="deactivateStage(stage.id)"
                  @editStage="openStageModal(stage)"
                  @newFlatClick="openFlatModal(stage.id)"
                  @editClick="editFlat"
                  @deleteClick="deleteFlat"
                  @getCalculations="openCalculationsModal"
                />
              </b-col>
            </b-row>
          </div>
        </b-tab>
      </b-tabs>
    </div>
    <section-modal
      :def-obj="section_to_edit"
      :is-edit="section_edit"
      @saved="FETCH_APARTMENT_SECTIONS($route.params.id)"
    />
    <stage-modal
      v-if="new_stage.section"
      :def-obj="new_stage"
      :is-edit="is_stage_edit"
      @saveSuccess="FETCH_STAGES_BY_SECTION({ id: active_tab_id })"
    />
    <flat-modal
      v-if="flat.stage"
      :def_form_obj="flat"
      :def_area="flat_area"
      :def_nonliving_area="flat_nonliving_area"
      :def_area_fields="flat_area_fields"
      :is-edit="flat.isEdit"
      @addSuccess="flatAddSuccess"
    />
    <calculations-modal v-if="flat_id_to_calc" :flat_id="flat_id_to_calc" />
    <EntranceDublicate />
  </div>
</template>

<script>
import { BButton, BTabs, BTab, BRow, BCol, VBModal } from "bootstrap-vue";
import { mapMutations, mapActions, mapGetters } from "vuex";
import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
import collapsibleStageCard from "./components/collapsibleStageCard.vue";
import sectionModal from "./components/modals/sectionModal.vue";
import stageModal from "./components/modals/stageModal.vue";
import flatModal from "./components/modals/flatModal.vue";
import CalculationsModal from "./components/modals/calculationsModal.vue";
import formatters from "@/mixins/extra";
import EntranceDublicate from "./components/modals/EntranceDublicate.vue";

export default {
  components: {
    BButton,
    FeatherIcon,
    BTabs,
    BTab,
    collapsibleStageCard,
    BRow,
    BCol,
    sectionModal,
    stageModal,
    flatModal,
    CalculationsModal,
    EntranceDublicate,
  },
  mixins: [formatters],
  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      tabs: [
        {
          id: 1,
          title: `${this.$t("objects.entrance")}'1'`,
        },
        {
          id: 2,
          title: `${this.$t("objects.entrance")}'2'`,
        },
      ],
      items: [
        {
          id: 1,
          flat_number: "1",
          rooms_count: "2",
          total_area: "75",
          total_price: "250000000",
          status: true,
          is_studio: false,
          free_planning: false,
        },
        {
          id: 2,
          flat_number: "1",
          rooms_count: "2",
          total_area: "75",
          total_price: "250000000",
          status: true,
          is_studio: false,
          free_planning: false,
        },
      ],
      new_stage: {
        section: null,
      },
      flat: {
        stage: null,
        total_area: 0,
        total_bti_area: 0,
        decoration: 2,
      },
      flat_id_to_calc: null,
      flat_area_fields: [],
      flat_area: [],
      flat_nonliving_area: [],
      is_stage_edit: false,
      active_tab_id: null,
      section_edit: false,
      section_to_edit: {
        apartment: Number(this.$route.params.id),
        // sort: 0,
      },
      obj: {
        name: "",
      },
      field_def: {
        id: "123",
        placeholder: "placeholder",
      },
    };
  },
  computed: {
    ...mapGetters("apartments", [
      "GET_ONE_APARTMENT",
      "GET_APARTMENT_MAIN_INFO",
    ]),
    ...mapGetters("sections", ["GET_SECTIONS"]),
    ...mapGetters("stages", ["GET_STAGES"]),
  },
  watch: {
    "obj.name": async function(newVal, oldVal) {
      console.log(oldVal);
      console.log(newVal);
    },
    active_tab_id() {
      if (this.GET_SECTIONS.length) {
        this.FETCH_STAGES_BY_SECTION({
          id: this.active_tab_id || this.GET_SECTIONS[0].id,
        });
      }
    },
  },
  mounted() {
    this.FETCH_ONE_APARTMENT(this.$route.params.id).then(() => {
      this.updateBreadcrumb();
    });
    this.refresh();
  },
  methods: {
    ...mapMutations("breadcrumb", ["UPDATE_BREADCRUMB"]),
    ...mapActions("apartments", ["FETCH_ONE_APARTMENT"]),
    ...mapActions("sections", ["FETCH_APARTMENT_SECTIONS", "EDIT_SECTION"]),
    ...mapActions("stages", [
      "ADD_STAGE",
      "FETCH_STAGES_BY_SECTION",
      "EDIT_STAGE",
    ]),
    ...mapActions("flats", ["EDIT_FLAT"]),
    updateBreadcrumb() {
      const [first, second, third, fourth] = this.$_removeObjectConnection(
        this.$route.meta.breadcrumb
      );
      second.text = this.GET_APARTMENT_MAIN_INFO.rc_object;
      second.to = second.to.replace(":id", this.GET_ONE_APARTMENT.rc_object);
      third.text = this.GET_ONE_APARTMENT.title;
      third.to = third.to.replace(":id", this.GET_ONE_APARTMENT.id);
      this.UPDATE_BREADCRUMB([first, second, third, fourth]);
    },
    showSection(section_id) {
      this.active_tab_id = section_id;
    },
    refresh() {
      this.FETCH_APARTMENT_SECTIONS(this.$route.params.id).then(() => {
        this.active_tab_id = this.GET_SECTIONS[0].id;
        const { sort } = this.GET_SECTIONS[this.GET_SECTIONS.length - 1];
        this.section_to_edit.sort = sort + 1;
        this.section_to_edit.title = "";
      });
    },
    editSection(tab) {
      this.$nextTick(() => {
        this.section_edit = true;
        this.section_to_edit = tab;
      });
    },
    deactivateSection(section_id) {
      console.log(section_id);
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.EDIT_SECTION({ id: section_id, is_active: false })
            .then(() => {
              this.refresh();
              this.$_successToast(this.$t("generals.added"));
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    deactivateStage(stage_id) {
      console.log(stage_id);
      this.$_showAreYouSureModal().then((value) => {
        if (value) {
          this.EDIT_STAGE({ id: stage_id, is_active: false })
            .then(() => {
              this.FETCH_STAGES_BY_SECTION({ id: this.active_tab_id });
              this.$_successToast(this.$t("generals.deleted"));
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
    openStageModal(stage) {
      this.is_stage_edit = true;
      this.new_stage = this.$_removeObjectConnection(stage);
      this.$nextTick(() => {
        this.$bvModal.show("stage-modal");
      });
    },
    openNewStageModal(tab_id) {
      this.is_stage_edit = false;
      this.new_stage = {
        section: tab_id,
      };
    },
    openFlatModal(stage_id) {
      this.flat.isEdit = false;
      // this.flat.stage = stage_id
      this.flat_area = [];
      this.flat_area = [];
      this.flat_nonliving_area = [];
      this.flat = {
        stage: stage_id,
        total_area: 0,
        total_bti_area: 0,
        decoration: 2,
      };
    },
    openCalculationsModal(id) {
      console.log(id);
      this.flat_id_to_calc = id;
      this.$nextTick(() => {
        this.$bvModal.show("calc-modal");
      });
    },
    flatAddSuccess() {
      this.$bvModal.hide("flat-modal");
      this.flat = {
        stage: null,
      };
      this.FETCH_STAGES_BY_SECTION({ id: this.active_tab_id });
    },
    editFlat(flat) {
      const {
        areas,
        current_status,
        characteristics,
        description,
        output_window,
        ...rest
      } = flat;
      const living_area = areas.filter((el) => el.is_living);
      const nonliving_area = areas.filter((el) => !el.is_living);
      const flat_to_edit = {
        ...rest,
        characteristics: characteristics.map((el) => el.id),
        current_status: current_status.id,
        description_uz: description ? description.uz : "",
        description_ru: description ? description.ru : "",
        description_en: description ? description.en : "",
        output_window: output_window.id,
      };
      this.flat_area = living_area;
      this.flat_nonliving_area = nonliving_area;
      this.flat = this.$_removeObjectConnection(flat_to_edit);
      this.flat.isEdit = true;
    },
    deleteFlat(flat_id) {
      this.$_showAreYouSureModal().then((val) => {
        if (val) {
          this.EDIT_FLAT({ id: flat_id, is_active: false })
            .then(() => {
              this.$_successToast(this.$t("generals.deleted"));
              this.FETCH_STAGES_BY_SECTION({ id: this.active_tab_id });
            })
            .catch(() => {
              this.$_errorToast(this.$t("generals.error"));
            });
        }
      });
    },
  },
};
</script>

<style></style>
